import { Tab, Tabs } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { lang } from 'src/utils';

import { CustomTooltip } from '../tooltip/CustomTooltip';
import { AppTabsProps } from './AppTabs.interface';
import { LabelContainer, StyledInfoIcon } from './AppTabs.style';

export const AppTabs = ({
  tabs,
  basePath = '',
  useRouting = true,
  value,
  onChange,
}: AppTabsProps) => {
  const location = useLocation();
  const navigate = useNavigate();

  const currentTab = () => {
    if (!useRouting) return value ?? 0;

    const matchIndex = tabs.findIndex((tab) =>
      location.pathname.endsWith(tab.path ?? ''),
    );

    return matchIndex === -1 ? 0 : matchIndex;
  };

  const handleChange = (_: React.SyntheticEvent, newValue: number) => {
    if (useRouting) {
      const nextPath = tabs[newValue].path;
      if (nextPath) navigate(`${basePath}/${nextPath}`);
    } else {
      onChange?.(newValue);
    }
  };

  return (
    <Tabs value={currentTab()} onChange={handleChange} variant="standard">
      {tabs.map((tab) => (
        <Tab
          key={tab.label}
          label={
            <LabelContainer gap={1}>
              {tab.label}
              {tab?.label === lang.unassignedLocations && (
                <CustomTooltip
                  key={tab.label}
                  placement="right"
                  skipValidateOverflow
                  title={lang.unassignedLocationsInfo}>
                  <StyledInfoIcon color="secondary" fontSize="small" />
                </CustomTooltip>
              )}
            </LabelContainer>
          }
          sx={{ textTransform: 'none' }}
          data-testid={tab.testId}
        />
      ))}
    </Tabs>
  );
};
